import { render, staticRenderFns } from "./prodimg.vue?vue&type=template&id=8ca6b1aa&"
import script from "./prodimg.vue?vue&type=script&lang=js&"
export * from "./prodimg.vue?vue&type=script&lang=js&"
import style0 from "./prodimg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports